import { render, staticRenderFns } from "./BatchProposalSender.vue?vue&type=template&id=44f324e2&scoped=true&"
import script from "./BatchProposalSender.vue?vue&type=script&lang=js&"
export * from "./BatchProposalSender.vue?vue&type=script&lang=js&"
import style0 from "./BatchProposalSender.vue?vue&type=style&index=0&id=44f324e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f324e2",
  null
  
)

export default component.exports